import React from "react";
import { CheckCircle2, CalendarCheck } from "lucide-react";
import { whatsappLink, HERO_IMG } from "../../lib/site";

const indicators = [
  "Atendimento humanizado",
  "Tratamento personalizado",
  "Técnicas atualizadas",
  "Foco na qualidade de vida",
];

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="hero-bg relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 pt-12 lg:pt-20 pb-20 lg:pb-28 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* LEFT */}
        <div className="lg:col-span-7 reveal">
          <p className="overline text-[#0D3B66]/70 mb-6">
            Especialista em Tratamento da Dor
          </p>
          <h1
            data-testid="hero-headline"
            className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#0A2540] leading-[1.05] tracking-tight"
          >
            Mais qualidade de vida através do{" "}
            <span className="italic font-normal text-[#0D3B66]">
              tratamento especializado da dor
            </span>
            <span className="text-[#D4AF37]">.</span>
          </h1>

          <p className="mt-8 text-lg text-[#1A1A1A]/70 max-w-2xl leading-relaxed">
            Tratamento com <strong className="text-[#0A2540]">Toxina Botulínica</strong>{" "} para distúrbios do movimento, dor crônica e condições neuromotoras. —
            conduzido por profissional habilitada, com protocolo individualizado
            e acolhimento em cada etapa.
          </p>

          {/* CTAs */}
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              data-testid="hero-cta-schedule"
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] hover:bg-[#E5C158] text-[#0A2540] font-semibold px-7 py-4 rounded-sm transition-all duration-300 shadow-md hover:-translate-y-0.5"
            >
              <CalendarCheck className="w-5 h-5" />
              Agendar Consulta
            </a>
          </div>

          {/* Indicators */}
          <ul
            data-testid="hero-indicators"
            className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 max-w-xl"
          >
            {indicators.map((ind) => (
              <li
                key={ind}
                className="flex items-start gap-3 text-[#0A2540]/85 text-sm"
              >
                <CheckCircle2 className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span>{ind}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* RIGHT - Doctor image */}
        <div className="lg:col-span-5 reveal">
          <div className="relative">
            <div
              aria-hidden
              className="absolute -inset-6 sm:-inset-10 rounded-full bg-gradient-to-br from-[#D4AF37]/15 via-transparent to-[#0D3B66]/10 blur-2xl"
            />
            <div className="relative aspect-square max-w-md mx-auto">
              <img
                data-testid="hero-doctor-image"
                src={HERO_IMG}
                alt="Dra. Luz Adriana — especialista no tratamento da dor"
                className="w-full h-full object-cover rounded-full shadow-2xl"
              />
              {/* name badge */}
              <div
                data-testid="hero-badge-name"
                className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-white shadow-xl border border-[#E9ECEF] rounded-full px-7 py-3 flex items-center gap-3 whitespace-nowrap"
              >
                <span className="w-2 h-2 rounded-full bg-[#D4AF37]" aria-hidden />
                <p className="font-serif-display text-[#0A2540] text-lg sm:text-xl leading-none">
                  Dra. Luz Adriana
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
